(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    /* A custom element reconnects itself after Horizon/Fabric AJAX morphing.
     Mirrors the existing canonical cartTotal node; does not add fees or
     modify the protection app's switch / cart updates. */
  if (!customElements.get('boupo-drawer-total-sync')) {
    class BoupoDrawerTotalSync extends HTMLElement {
      connectedCallback() {
        this.summary = this.closest('[data-boupo-drawer-summary]');
        if (!this.summary) return;
        this.queued = false;
        this.observer = new MutationObserver(() => this.schedule());
        this.observer.observe(this.summary, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['value']
        });
        this.schedule();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
      schedule() {
        if (this.queued) return;
        this.queued = true;
        queueMicrotask(() => {
          this.queued = false;
          if (!this.isConnected) return;
          const source = this.summary.querySelector('text-component[ref="cartTotal"][data-cart-subtotal]');
          const target = this.summary.querySelector('[data-boupo-checkout-amount]');
          if (!source || !target) return;
          const total = (source.textContent || source.getAttribute('value') || '').replace(/\s+/g, ' ').trim();
          if (total && target.textContent.trim() !== total) target.textContent = total;
        });
      }
    }
    customElements.define('boupo-drawer-total-sync', BoupoDrawerTotalSync);
  }
  } catch(e) { console.error(e); }
})();

})();
